import Slider from "react-slick";
import "../../../assets/css/homeBanner.css";
import bannerImage1 from "../../../assets/images/mainSlider/slider.webp";
import bannerImage2 from "../../../assets/images/mainSlider/slider.webp";
import bannerImage3 from "../../../assets/images/mainSlider/slider.webp";

const SliderArrow = ({ className, onClick, direction }) => (
  <button
    type="button"
    className={`${className} home-slider-arrow home-slider-arrow--${direction}`}
    onClick={onClick}
    aria-label={direction === "prev" ? "Previous slide" : "Next slide"}
  >
    <i className={`ph ph-caret-${direction === "prev" ? "left" : "right"}`} />
  </button>
);

const slides = [
  { id: 1, image: bannerImage1, alt: "Fresh fish deals" },
  { id: 2, image: bannerImage2, alt: "Premium seafood" },
  { id: 3, image: bannerImage3, alt: "Daily fish delivery" },
];

const sliderSettings = {
  dots: true,
  infinite: slides.length > 1,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  pauseOnHover: true,
  arrows: true,
  prevArrow: <SliderArrow direction="prev" />,
  nextArrow: <SliderArrow direction="next" />,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        dots: true,
        autoplaySpeed: 2500,
      },
    },
  ],
};

const HomeSlider = () => (
  <div className="home-image-slider">
    <div className="container container-lg px-0">
      <div className="home-image-slider__wrapper">
        <Slider {...sliderSettings}>
          {slides.map((slide) => (
            <div key={slide.id}>
              <div className="home-image-slider__item mx-0">
                <img
                  src={slide.image}
                  alt={slide.alt}
                  className="home-image-slider__img"
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  </div>
);

export default HomeSlider;
